/**
 * BUNDLE CREATOR LOGIC - NEW ROW-BASED STRUCTURE
 * ===============================================
 *
 * DATA STRUCTURE:
 * - products: Object storing selected products { variantId: { priceCents, quantity, title, imgSrc } }
 *
 * CORE FUNCTIONALITY:
 * 1. ADD PRODUCT: Click "Add" button → adds product to next empty slot row
 * 2. QUANTITY CONTROL: +/- buttons to adjust quantity
 * 3. REMOVE PRODUCT: Trash button on row removes that product
 * 4. PRICING: Variant price in cents from Liquid; discount per line = floor(line_cents * % / 100) like Shopify cart
 * 5. ADD TO CART: When 6+ items selected, bundle can be added to Shopify cart
 */

const BUNDLE_REMOVE_ICON_SVG = `<span aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
  <mask id="mask0_3893_5219" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
    <rect width="24" height="24" fill="#D9D9D9"/>
  </mask>
  <g mask="url(#mask0_3893_5219)">
    <path d="M7.6155 20C7.17117 20 6.79083 19.8418 6.4745 19.5255C6.15817 19.2091 6 18.8288 6 18.3845V5.99996H5.5C5.35833 5.99996 5.23958 5.95196 5.14375 5.85596C5.04792 5.75996 5 5.64105 5 5.49921C5 5.35738 5.04792 5.23871 5.14375 5.14321C5.23958 5.04771 5.35833 4.99996 5.5 4.99996H9C9 4.79363 9.07658 4.6138 9.22975 4.46046C9.38292 4.3073 9.56275 4.23071 9.76925 4.23071H14.2308C14.4373 4.23071 14.6171 4.3073 14.7703 4.46046C14.9234 4.6138 15 4.79363 15 4.99996H18.5C18.6417 4.99996 18.7604 5.04796 18.8562 5.14396C18.9521 5.23996 19 5.35888 19 5.50071C19 5.64255 18.9521 5.76121 18.8562 5.85671C18.7604 5.95221 18.6417 5.99996 18.5 5.99996H18V18.3845C18 18.8288 17.8418 19.2091 17.5255 19.5255C17.2092 19.8418 16.8288 20 16.3845 20H7.6155ZM17 5.99996H7V18.3845C7 18.564 7.05767 18.7115 7.173 18.827C7.2885 18.9423 7.436 19 7.6155 19H16.3845C16.564 19 16.7115 18.9423 16.827 18.827C16.9423 18.7115 17 18.564 17 18.3845V5.99996ZM10.6645 16.8562C10.76 16.7604 10.8078 16.6416 10.8078 16.5V8.49996C10.8078 8.3583 10.7597 8.23955 10.6637 8.14371C10.5677 8.04788 10.4488 7.99996 10.307 7.99996C10.1652 7.99996 10.0465 8.04788 9.951 8.14371C9.8555 8.23955 9.80775 8.3583 9.80775 8.49996V16.5C9.80775 16.6416 9.85575 16.7604 9.95175 16.8562C10.0476 16.952 10.1664 17 10.3082 17C10.4503 17 10.569 16.952 10.6645 16.8562ZM14.049 16.8562C14.1445 16.7604 14.1923 16.6416 14.1923 16.5V8.49996C14.1923 8.3583 14.1442 8.23955 14.0483 8.14371C13.9524 8.04788 13.8336 7.99996 13.6917 7.99996C13.5497 7.99996 13.431 8.04788 13.3355 8.14371C13.24 8.23955 13.1923 8.3583 13.1923 8.49996V16.5C13.1923 16.6416 13.2403 16.7604 13.3363 16.8562C13.4323 16.952 13.5512 17 13.693 17C13.8348 17 13.9535 16.952 14.049 16.8562Z" fill="#1C1B1F"/>
  </g>
</svg></span>`;

document.addEventListener('DOMContentLoaded', () => {
  const bundleContainer = document.querySelector('.bundle-creator-new');
  if (!bundleContainer) return;

  // Get translations from data attributes
  const translations = {
    adding: bundleContainer.dataset.tAdding || 'Adding...',
    added: bundleContainer.dataset.tAdded || 'Added!',
    addToCart: bundleContainer.dataset.tAddToCart || 'ADD TO CART',
    free: bundleContainer.dataset.tFree || 'FREE',
    calculated: bundleContainer.dataset.tCalculated || 'Calculated at checkout',
    discountUnlocked: bundleContainer.dataset.tDiscountUnlocked || 'Discount unlocked!',
    addMoreProducts: bundleContainer.dataset.tAddMoreProducts || 'Add more products',
    itemsOne: bundleContainer.dataset.tItemsOne || '__COUNT__ item',
    itemsOther: bundleContainer.dataset.tItemsOther || '__COUNT__ items',
    progressOne: bundleContainer.dataset.tProgressOne || 'Add __COUNT__ more item for 20% OFF.',
    progressOther: bundleContainer.dataset.tProgressOther || 'Add __COUNT__ more items for 20% OFF.',
    progress25One: bundleContainer.dataset.tProgress25One || 'Add __COUNT__ more item for 25% OFF.',
    progress25Other: bundleContainer.dataset.tProgress25Other || 'Add __COUNT__ more items for 25% OFF.',
  };

  const slotsListContainer = bundleContainer.querySelector('.bundle-creator-new__slots-list');
  const addToCartButton = bundleContainer.querySelector('.bundle-creator-new__add-to-cart');
  const subtotalElement = bundleContainer.querySelector('.bundle-creator-new__subtotal');
  const savingsElement = bundleContainer.querySelector('.bundle-creator-new__savings');
  const shippingElement = bundleContainer.querySelector('.bundle-creator-new__shipping');
  const totalElement = bundleContainer.querySelector('.bundle-creator-new__total');
  const addToCartPriceElement = bundleContainer.querySelector('.bundle-creator-new__add-to-cart-price');
  const itemsRemainingElement = bundleContainer.querySelector('.bundle-creator-new__items-remaining');
  const progressTextElement = bundleContainer.querySelector('.bundle-creator-new__tiers-progress');
  const selectedProductsPanel = bundleContainer.querySelector('.bundle-creator-new__selected-products');
  const scrollContainer = bundleContainer.querySelector('.bundle-creator-new__products-scroll-container');

  // Mobile elements
  const mobileExpandBtn = bundleContainer.querySelector('.bundle-creator-new__mobile-expand-btn');
  const mobileCollapseBtn = bundleContainer.querySelector('.bundle-creator-new__mobile-collapse-btn');
  const progressTextMobile = bundleContainer.querySelector('.bundle-creator-new__progress-text-mobile');
  const itemsRemainingMobile = bundleContainer.querySelector('.bundle-creator-new__items-remaining-mobile');
  const itemCountMobile = bundleContainer.querySelector('.bundle-creator-new__item-count-mobile');
  const mobileCollapsed = bundleContainer.querySelector('.bundle-creator-new__mobile-collapsed');
  const itemsRemainingExpandedTop = bundleContainer.querySelector('.bundle-creator-new__items-remaining-expanded-top');
  const progressTextExpanded = bundleContainer.querySelector('.bundle-creator-new__progress-text-expanded');
  const overlay = bundleContainer.querySelector('.bundle-creator-new__overlay');

  // Mobile ATC elements
  const mobileAddToCartBtn = bundleContainer.querySelector('.bundle-creator-new__add-to-cart-mobile');
  const mobileAddToCartPrice = bundleContainer.querySelector('.bundle-creator-new__add-to-cart-price-mobile');

  const bundleId = crypto.randomUUID();
  const products = {};

  // Helper function to convert text to title case
  function toTitleCase(str) {
    return str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
  }

  // Mobile expand/collapse functionality
  function syncMobileExpandedAria(isExpanded) {
    if (mobileExpandBtn) {
      mobileExpandBtn.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
    }
  }

  function expandMobilePanel() {
    selectedProductsPanel.classList.add('expanded');
    bundleContainer.classList.add('mobile-expanded');
    document.body.style.overflow = 'hidden';
    syncMobileExpandedAria(true);
  }

  function collapseMobilePanel() {
    selectedProductsPanel.classList.remove('expanded');
    bundleContainer.classList.remove('mobile-expanded');
    document.body.style.overflow = '';
    syncMobileExpandedAria(false);
  }

  if (mobileExpandBtn) {
    mobileExpandBtn.addEventListener('click', expandMobilePanel);
  }

  if (mobileCollapseBtn) {
    mobileCollapseBtn.addEventListener('click', collapseMobilePanel);
  }

  syncMobileExpandedAria(selectedProductsPanel && selectedProductsPanel.classList.contains('expanded'));

  if (overlay) {
    overlay.addEventListener('click', collapseMobilePanel);
  }

  // Also expand when clicking the collapsed area
  if (mobileCollapsed) {
    mobileCollapsed.addEventListener('click', (e) => {
      // Don't expand if clicking on interactive elements
      if (e.target.closest('.bundle-creator-new__mobile-expand-btn')) return;
      if (e.target.closest('.bundle-creator-new__mobile-collapse-btn')) return;
      if (e.target.closest('.bundle-creator-new__add-to-cart-mobile')) return;
      if (e.target.closest('.bundle-creator-new__cashback-mobile')) return;
      expandMobilePanel();
    });
  }

  // Set scroll container height to match selected products panel
  function updateScrollContainerHeight() {
    if (window.innerWidth >= 1000 && selectedProductsPanel && scrollContainer) {
      const tabsHeight = bundleContainer.querySelector('.bundle-creator-new__collection-tabs')?.offsetHeight || 0;
      const availableHeight = selectedProductsPanel.offsetHeight - tabsHeight - 24;
      scrollContainer.style.maxHeight = `${Math.max(availableHeight, 400)}px`;
    } else {
      scrollContainer.style.maxHeight = 'none';
    }
  }

  updateScrollContainerHeight();
  window.addEventListener('resize', updateScrollContainerHeight);

  addToCartButton.addEventListener('click', addAllProductsToCart);

  // Mobile ATC button click handler
  if (mobileAddToCartBtn) {
    mobileAddToCartBtn.addEventListener('click', addAllProductsToCart);
  }

  bundleContainer.querySelectorAll('.product-new__add-button').forEach((button) => {
    button.addEventListener('click', (event) => {
      event.stopPropagation();
      const btn = event.target.closest('.product-new__add-button');
      const productId = btn.dataset.variantId;
      addProductToBundle(productId);
    });
  });

  bundleContainer.querySelectorAll('.product-new__quantity-decrease').forEach((button) => {
    button.addEventListener('click', (event) => {
      event.stopPropagation();
      const btn = event.target.closest('.product-new__quantity-decrease');
      const productId = btn.dataset.variantId;
      updateProductQuantity(productId, -1);
    });
  });

  bundleContainer.querySelectorAll('.product-new__quantity-increase').forEach((button) => {
    button.addEventListener('click', (event) => {
      event.stopPropagation();
      const btn = event.target.closest('.product-new__quantity-increase');
      const productId = btn.dataset.variantId;
      updateProductQuantity(productId, 1);
    });
  });

  // Collection tab switching
  const collectionTabs = bundleContainer.querySelectorAll('.bundle-creator-new__collection-tab');

  function activateCollectionTab(targetTab) {
    if (!targetTab) return;
    const collectionId = targetTab.dataset.collectionId;

    collectionTabs.forEach((t) => {
      const isActive = t === targetTab;
      t.classList.toggle('active', isActive);
      t.setAttribute('aria-selected', isActive ? 'true' : 'false');
      t.setAttribute('tabindex', isActive ? '0' : '-1');
    });

    bundleContainer.querySelectorAll('.bundle-creator-new__collection-panel').forEach((panel) => {
      const list = panel.querySelector('.bundle-creator-new__collection-products');
      const isActivePanel = list && list.dataset.collectionId === collectionId;
      panel.classList.toggle('active', isActivePanel);
      if (isActivePanel) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', '');
      }
    });
  }

  collectionTabs.forEach((tab) => {
    tab.addEventListener('click', () => activateCollectionTab(tab));
    tab.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft' && event.key !== 'Home' && event.key !== 'End') {
        return;
      }
      event.preventDefault();
      const tabsArray = Array.from(collectionTabs);
      const currentIndex = tabsArray.indexOf(tab);
      let nextIndex = currentIndex;
      if (event.key === 'ArrowRight') {
        nextIndex = (currentIndex + 1) % tabsArray.length;
      } else if (event.key === 'ArrowLeft') {
        nextIndex = (currentIndex - 1 + tabsArray.length) % tabsArray.length;
      } else if (event.key === 'Home') {
        nextIndex = 0;
      } else if (event.key === 'End') {
        nextIndex = tabsArray.length - 1;
      }
      const nextTab = tabsArray[nextIndex];
      activateCollectionTab(nextTab);
      if (nextTab) nextTab.focus();
    });
  });

  /**
   * ADD ALL PRODUCTS TO CART
   */
  function addAllProductsToCart() {
    const totalItems = getTotalItemCount();
    if (totalItems < 6) return;

    addToCartButton.querySelector('.bundle-creator-new__add-to-cart-text').innerText = translations.adding;

    const items = Object.keys(products).map((productId) => ({
      id: productId,
      quantity: products[productId].quantity,
      properties: { _bundle_id: bundleId },
    }));

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items }),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log('Products added to cart:', data);
        addToCartButton.querySelector('.bundle-creator-new__add-to-cart-text').innerText = translations.added;
        if (window.robustCart) {
          window.robustCart.refreshCart();
          window.robustCart.openCart();
          moveFocusToMiniCart();
        }
      })
      .catch((error) => {
        console.error('Error adding products to cart:', error);
        addToCartButton.querySelector('.bundle-creator-new__add-to-cart-text').innerText = translations.addToCart;
      });
  }

  /**
   * MOVE FOCUS TO MINI CART
   *
   * After a successful add-to-cart, programmatically move keyboard focus to
   * the cart drawer so screen-reader and keyboard users are aware that the
   * cart has opened (audit issue 271).
   */
  function moveFocusToMiniCart() {
    const tryFocus = (attemptsLeft) => {
      const cartDialog = document.querySelector('.rc90-box.rc90-cart');
      if (cartDialog) {
        const closeBtn = cartDialog.querySelector('.rc90-header-close');
        const heading = cartDialog.querySelector('.rc90-header-title');
        const target = closeBtn || heading || cartDialog;
        if (target === cartDialog && !cartDialog.hasAttribute('tabindex')) {
          cartDialog.setAttribute('tabindex', '-1');
        }
        try {
          target.focus({ preventScroll: false });
        } catch (e) {
          /* element not focusable yet */
        }
        return;
      }
      if (attemptsLeft > 0) {
        window.setTimeout(() => tryFocus(attemptsLeft - 1), 80);
      }
    };
    /* Wait briefly for refreshCart() to re-render the drawer DOM. */
    window.setTimeout(() => tryFocus(8), 120);
  }

  /**
   * ADD PRODUCT TO BUNDLE
   */
  function addProductToBundle(productId) {
    const productElement = bundleContainer.querySelector(
      `.bundle-creator-new__product[data-variant-id="${productId}"]`
    );
    const addButton = productElement.querySelector('.bundle-creator-new__add-bundle-btn');
    const productTitle = addButton.getAttribute('data-product-title');
    const priceCentsAttr = addButton.getAttribute('data-variant-price-cents');
    const priceCents = priceCentsAttr
      ? parseInt(priceCentsAttr, 10)
      : Math.round(
          parseFloat(
            productElement.querySelector('.bundle-creator-new__product-price').innerText.replace(/[$,]/g, '')
          ) * 100
        );
    const productImgSrc = productElement.querySelector('img').src;

    if (!products[productId]) {
      products[productId] = { priceCents, quantity: 0, title: productTitle, imgSrc: productImgSrc };
    }

    products[productId].quantity += 1;

    displayProductInSlot(productId);
    updateUI();

    // Update ALL product cards with this variant ID
    bundleContainer
      .querySelectorAll(`.bundle-creator-new__product[data-variant-id="${productId}"] .product-new__add-button`)
      .forEach((btn) => (btn.style.display = 'none'));
    bundleContainer
      .querySelectorAll(
        `.bundle-creator-new__product[data-variant-id="${productId}"] .product-new__quantity-selector`
      )
      .forEach((sel) => (sel.style.display = 'flex'));
    bundleContainer
      .querySelectorAll(`.bundle-creator-new__product[data-variant-id="${productId}"] .product-new__quantity`)
      .forEach((qty) => (qty.innerText = products[productId].quantity));
  }

  /**
   * DISPLAY PRODUCT IN SLOT ROW
   */
  function displayProductInSlot(productId) {
    createNewSlotsIfNecessary();

    const emptySlot = findEmptySlotRow();
    if (!emptySlot) return;

    const product = products[productId];
    const emptyState = emptySlot.querySelector('.bundle-creator-new__slot-row-empty');
    const filledState = emptySlot.querySelector('.bundle-creator-new__slot-row-filled');

    emptyState.style.display = 'none';
    filledState.style.display = 'flex';

    filledState.querySelector('.bundle-creator-new__slot-row-img').src = product.imgSrc;
    filledState.querySelector('.bundle-creator-new__slot-row-img').alt = '';
    filledState.querySelector('.bundle-creator-new__slot-row-title').innerText = product.title;
    filledState.querySelector('.bundle-creator-new__slot-row-price').innerText = `$${(product.priceCents / 100).toFixed(2)}`;
    filledState.querySelector('.bundle-creator-new__slot-row-remove').dataset.variantId = productId;

    // Add click handler for remove button
    const removeBtn = filledState.querySelector('.bundle-creator-new__slot-row-remove');
    removeBtn.setAttribute('aria-label', `Remove ${product.title} from bundle`);
    removeBtn.onclick = () => removeProductFromBundle(productId);
  }

  /**
   * FIND EMPTY SLOT ROW
   */
  function findEmptySlotRow() {
    return [...slotsListContainer.querySelectorAll('.bundle-creator-new__slot-row')].find((row) => {
      return row.querySelector('.bundle-creator-new__slot-row-empty').style.display !== 'none';
    });
  }

  /**
   * CREATE NEW SLOTS IF NECESSARY
   */
  function createNewSlotsIfNecessary() {
    const allSlots = slotsListContainer.querySelectorAll('.bundle-creator-new__slot-row');
    const filledSlots = [...allSlots].filter(
      (row) => row.querySelector('.bundle-creator-new__slot-row-empty').style.display === 'none'
    );

    if (filledSlots.length >= allSlots.length - 1) {
      for (let i = 0; i < 3; i++) {
        const slotIndex = allSlots.length + i + 1;
        const newSlot = document.createElement('li');
        newSlot.className = 'bundle-creator-new__slot-row';
        newSlot.id = `bundle-slot-row-${slotIndex}`;
        newSlot.dataset.slotIndex = slotIndex;
        newSlot.innerHTML = `
          <div class="bundle-creator-new__slot-row-empty" role="group" aria-label="Empty item slot ${slotIndex}, add an item">
              <span class="bundle-creator-new__slot-row-plus" aria-hidden="true">+</span>
              <span class="bundle-creator-new__slot-row-text">${translations.addMoreProducts}</span>
          </div>
          <div class="bundle-creator-new__slot-row-filled" style="display: none;" role="group" aria-label="Bundle slot ${slotIndex}">
              <img src="" alt="" class="bundle-creator-new__slot-row-img" width="100" height="100" aria-hidden="true">
              <div class="bundle-creator-new__slot-row-info">
                  <h2 class="bundle-creator-new__slot-row-title"></h2>
              </div>
              <span class="bundle-creator-new__slot-row-price"></span>
              <button type="button" class="bundle-creator-new__slot-row-remove" data-variant-id="" aria-label="Remove item from bundle">
                  ${BUNDLE_REMOVE_ICON_SVG}
              </button>
          </div>
        `;
        slotsListContainer.appendChild(newSlot);
      }
    }
  }

  /**
   * REMOVE PRODUCT FROM BUNDLE
   */
  function removeProductFromBundle(productId) {
    // Find the slot with this product
    const slot = [...slotsListContainer.querySelectorAll('.bundle-creator-new__slot-row')].find((row) => {
      const removeBtn = row.querySelector('.bundle-creator-new__slot-row-remove');
      return (
        removeBtn &&
        removeBtn.dataset.variantId === productId &&
        row.querySelector('.bundle-creator-new__slot-row-empty').style.display === 'none'
      );
    });

    if (!slot) return;

    // Reset slot to empty state
    const emptyState = slot.querySelector('.bundle-creator-new__slot-row-empty');
    const filledState = slot.querySelector('.bundle-creator-new__slot-row-filled');
    emptyState.style.display = 'flex';
    filledState.style.display = 'none';
    const resetRemoveBtn = filledState.querySelector('.bundle-creator-new__slot-row-remove');
    resetRemoveBtn.dataset.variantId = '';
    resetRemoveBtn.setAttribute('aria-label', 'Remove item from bundle');

    products[productId].quantity -= 1;

    if (products[productId].quantity === 0) {
      delete products[productId];
      // Reset ALL product cards with this variant ID
      bundleContainer
        .querySelectorAll(`.bundle-creator-new__product[data-variant-id="${productId}"] .product-new__add-button`)
        .forEach((btn) => (btn.style.display = 'flex'));
      bundleContainer
        .querySelectorAll(
          `.bundle-creator-new__product[data-variant-id="${productId}"] .product-new__quantity-selector`
        )
        .forEach((sel) => (sel.style.display = 'none'));
    } else {
      // Update ALL quantity displays for this variant ID
      bundleContainer
        .querySelectorAll(`.bundle-creator-new__product[data-variant-id="${productId}"] .product-new__quantity`)
        .forEach((qty) => (qty.innerText = products[productId].quantity));
    }

    shiftSlotsUp();
    updateUI();
  }

  /**
   * SHIFT SLOTS UP after removal
   */
  function shiftSlotsUp() {
    const allSlots = [...slotsListContainer.querySelectorAll('.bundle-creator-new__slot-row')];
    const filledData = [];

    // Collect all filled slot data
    allSlots.forEach((slot) => {
      const emptyState = slot.querySelector('.bundle-creator-new__slot-row-empty');
      if (emptyState.style.display === 'none') {
        const filledState = slot.querySelector('.bundle-creator-new__slot-row-filled');
        filledData.push({
          imgSrc: filledState.querySelector('.bundle-creator-new__slot-row-img').src,
          imgAlt: '',
          title: filledState.querySelector('.bundle-creator-new__slot-row-title').innerText,
          price: filledState.querySelector('.bundle-creator-new__slot-row-price').innerText,
          variantId: filledState.querySelector('.bundle-creator-new__slot-row-remove').dataset.variantId,
        });
      }
    });

    // Reset all slots to empty
    allSlots.forEach((slot, index) => {
      const emptyState = slot.querySelector('.bundle-creator-new__slot-row-empty');
      const filledState = slot.querySelector('.bundle-creator-new__slot-row-filled');
      emptyState.style.display = 'flex';
      filledState.style.display = 'none';
      const removeBtn = filledState.querySelector('.bundle-creator-new__slot-row-remove');
      if (removeBtn) {
        removeBtn.dataset.variantId = '';
        removeBtn.setAttribute('aria-label', 'Remove item from bundle');
      }
    });

    // Refill slots from top
    filledData.forEach((data, index) => {
      if (index < allSlots.length) {
        const slot = allSlots[index];
        const emptyState = slot.querySelector('.bundle-creator-new__slot-row-empty');
        const filledState = slot.querySelector('.bundle-creator-new__slot-row-filled');

        emptyState.style.display = 'none';
        filledState.style.display = 'flex';
        filledState.querySelector('.bundle-creator-new__slot-row-img').src = data.imgSrc;
        filledState.querySelector('.bundle-creator-new__slot-row-img').alt = '';
        filledState.querySelector('.bundle-creator-new__slot-row-title').innerText = data.title;
        filledState.querySelector('.bundle-creator-new__slot-row-price').innerText = data.price;
        const shiftedRemoveBtn = filledState.querySelector('.bundle-creator-new__slot-row-remove');
        shiftedRemoveBtn.dataset.variantId = data.variantId;
        shiftedRemoveBtn.setAttribute('aria-label', `Remove ${data.title} from bundle`);
        shiftedRemoveBtn.onclick = () => removeProductFromBundle(data.variantId);
      }
    });

    // Remove excess empty slots (keep min 6)
    removeExcessSlots();
  }

  /**
   * REMOVE EXCESS EMPTY SLOTS
   */
  function removeExcessSlots() {
    const allSlots = [...slotsListContainer.querySelectorAll('.bundle-creator-new__slot-row')];
    const minSlots = 6;
    const emptyBuffer = 2; // Keep 2 empty slots after filled ones

    // Count filled slots
    let filledCount = 0;
    allSlots.forEach((slot) => {
      const emptyState = slot.querySelector('.bundle-creator-new__slot-row-empty');
      if (emptyState.style.display === 'none') {
        filledCount++;
      }
    });

    // Calculate desired total: filled slots + buffer, but never less than minimum
    const desiredTotal = Math.max(minSlots, filledCount + emptyBuffer);

    // Remove excess slots from the end
    while (allSlots.length > desiredTotal) {
      const lastSlot = slotsListContainer.querySelector('.bundle-creator-new__slot-row:last-child');
      if (lastSlot) lastSlot.remove();
      allSlots.pop();
    }
  }

  /**
   * UPDATE PRODUCT QUANTITY
   */
  function updateProductQuantity(productId, change) {
    if (!products[productId]) return;

    const newQuantity = products[productId].quantity + change;

    if (newQuantity < 1) {
      // Remove all instances of this product from slots
      while (products[productId] && products[productId].quantity > 0) {
        removeProductFromBundle(productId);
      }
      return;
    }

    if (change > 0) {
      // Add more slots
      for (let i = 0; i < change; i++) {
        displayProductInSlot(productId);
      }
      products[productId].quantity = newQuantity;
    } else {
      // Remove slots
      for (let i = 0; i < Math.abs(change); i++) {
        removeProductFromBundle(productId);
      }
    }

    // Update ALL quantity displays
    bundleContainer
      .querySelectorAll(`.bundle-creator-new__product[data-variant-id="${productId}"] .product-new__quantity`)
      .forEach((qty) => {
        qty.innerText = products[productId] ? products[productId].quantity : 0;
      });

    updateUI();
  }

  /**
   * GET TOTAL ITEM COUNT
   */
  function getTotalItemCount() {
    return Object.values(products).reduce((sum, product) => sum + product.quantity, 0);
  }

  /**
   * Bundle tier discount (must match tier UI: 6+ → 20%, 8+ → 25%)
   */
  function getBundleDiscountPercent(totalItems) {
    if (totalItems >= 8) return 25;
    if (totalItems >= 6) return 20;
    return 0;
  }

  /**
   * Per-line discount in cents, summed — matches Shopify: floor((line_cents * percent) / 100) per line.
   */
  function sumPerLineBundleSavingsCents(productsMap, discountPercent) {
    if (discountPercent <= 0) return 0;
    return Object.values(productsMap).reduce((sum, product) => {
      const lineCents = product.priceCents * product.quantity;
      return sum + Math.floor((lineCents * discountPercent) / 100);
    }, 0);
  }

  /**
   * UPDATE UI
   */
  function updateUI() {
    const totalItems = getTotalItemCount();
    const subtotalCents = Object.values(products).reduce(
      (sum, product) => sum + product.priceCents * product.quantity,
      0
    );

    const discountPercent = getBundleDiscountPercent(totalItems);
    const savingsCents = sumPerLineBundleSavingsCents(products, discountPercent);
    const totalCents = subtotalCents - savingsCents;

    const subtotal = subtotalCents / 100;
    const savingsAmount = savingsCents / 100;
    const total = totalCents / 100;

    // Update summary (subtotal = pre-discount; savings = tier discount; total = after discount)
    subtotalElement.innerText = `$${subtotal.toFixed(2)}`;
    savingsElement.innerText = `$${savingsAmount.toFixed(2)}`;
    shippingElement.innerText = totalItems >= 5 ? translations.free : translations.calculated;
    totalElement.innerText = `$${total.toFixed(2)}`;
    addToCartPriceElement.innerText = `$${total.toFixed(2)}`;

    // Update mobile ATC prices
    if (mobileAddToCartPrice) {
      mobileAddToCartPrice.innerText = `$${total.toFixed(2)}`;
    }

    // Update progress text
    const remainingTo20 = Math.max(0, 6 - totalItems);
    const remainingTo25 = Math.max(0, 8 - totalItems);
    const remaining = remainingTo20 > 0 ? remainingTo20 : remainingTo25;
    const progressToward25 = remainingTo20 === 0 && remainingTo25 > 0;
    const progressTemplateFor = (count) => {
      if (progressToward25) {
        return count === 1 ? translations.progress25One : translations.progress25Other;
      }
      return count === 1 ? translations.progressOne : translations.progressOther;
    };
    if (progressTextElement) {
      const progressTemplate = progressTemplateFor(remaining);
      if (remaining > 0) {
        progressTextElement.innerHTML = progressTemplate.replace('__COUNT__', remaining);
        progressTextElement.style.display = 'block';
      } else {
        progressTextElement.style.display = 'none';
      }
    }

    // Update mobile progress text and item count
    if (progressTextMobile) {
      const progressTemplate = progressTemplateFor(remaining);
      if (remaining > 0) {
        progressTextMobile.innerHTML = progressTemplate.replace('__COUNT__', remaining);
      } else {
        progressTextMobile.innerHTML = `<span style="color: #000;">${translations.discountUnlocked}</span>`;
      }
    }
    if (itemCountMobile) {
      const itemsTemplate = totalItems === 1 ? translations.itemsOne : translations.itemsOther;
      itemCountMobile.innerText = itemsTemplate.replace('__COUNT__', totalItems);
    }
    if (itemsRemainingExpandedTop) {
      itemsRemainingExpandedTop.innerText = remaining;
    }

    // Update tiers (desktop)
    const tiers = bundleContainer.querySelectorAll('.bundle-creator-new__tiers .bundle-creator-new__tier');
    tiers.forEach((tier) => {
      const tierType = tier.dataset.tier;
      if (tierType === 'shipping') {
        tier.classList.toggle('active', totalItems >= 5);
      } else if (tierType === 'discount15') {
        tier.classList.toggle('active', totalItems >= 6);
      } else if (tierType === 'discount20') {
        tier.classList.toggle('active', totalItems >= 8);
      }
    });

    // Update start line (active when first tier is active)
    const tierLineStart = bundleContainer.querySelector('.bundle-creator-new__tier-line-start');
    if (tierLineStart) {
      tierLineStart.classList.toggle('active', totalItems >= 5);
    }

    // Update connectors (connector is active when NEXT tier is active)
    const shippingTier = bundleContainer.querySelector('.bundle-creator-new__tier[data-tier="shipping"]');
    const discount15Tier = bundleContainer.querySelector('.bundle-creator-new__tier[data-tier="discount15"]');
    if (shippingTier) {
      const connector = shippingTier.querySelector('.bundle-creator-new__tier-connector');
      if (connector) connector.classList.toggle('active', totalItems >= 6);
    }
    if (discount15Tier) {
      const connector = discount15Tier.querySelector('.bundle-creator-new__tier-connector');
      if (connector) connector.classList.toggle('active', totalItems >= 8);
    }

    // Update mobile tiers
    const mobileTiers = bundleContainer.querySelectorAll('.bundle-creator-new__tier-mobile');
    mobileTiers.forEach((tier) => {
      const tierType = tier.dataset.tier;
      if (tierType === 'shipping') {
        tier.classList.toggle('active', totalItems >= 5);
      } else if (tierType === 'discount15') {
        tier.classList.toggle('active', totalItems >= 6);
      } else if (tierType === 'discount20') {
        tier.classList.toggle('active', totalItems >= 8);
      }
    });

    // Update mobile start line
    const mobileStartLine = bundleContainer.querySelector('.bundle-creator-new__tier-line-start-mobile');
    if (mobileStartLine) {
      mobileStartLine.classList.toggle('active', totalItems >= 5);
    }

    // Update mobile connectors (connector is active when NEXT tier is active)
    const mobileShippingTier = bundleContainer.querySelector(
      '.bundle-creator-new__tier-mobile[data-tier="shipping"]'
    );
    const mobileDiscount15Tier = bundleContainer.querySelector(
      '.bundle-creator-new__tier-mobile[data-tier="discount15"]'
    );
    if (mobileShippingTier) {
      const connector = mobileShippingTier.querySelector('.bundle-creator-new__tier-connector-mobile');
      if (connector) connector.classList.toggle('active', totalItems >= 6);
    }
    if (mobileDiscount15Tier) {
      const connector = mobileDiscount15Tier.querySelector('.bundle-creator-new__tier-connector-mobile');
      if (connector) connector.classList.toggle('active', totalItems >= 8);
    }

    // Update expanded tiers
    const expandedTiers = bundleContainer.querySelectorAll('.bundle-creator-new__tier-expanded');
    expandedTiers.forEach((tier) => {
      const tierType = tier.dataset.tier;
      if (tierType === 'shipping') {
        tier.classList.toggle('active', totalItems >= 5);
      } else if (tierType === 'discount15') {
        tier.classList.toggle('active', totalItems >= 6);
      } else if (tierType === 'discount20') {
        tier.classList.toggle('active', totalItems >= 8);
      }
    });

    // Update expanded start line
    const expandedStartLine = bundleContainer.querySelector('.bundle-creator-new__tier-line-start-expanded');
    if (expandedStartLine) {
      expandedStartLine.classList.toggle('active', totalItems >= 5);
    }

    // Update expanded connectors (connector is active when NEXT tier is active)
    const expandedShippingTier = bundleContainer.querySelector('.bundle-creator-new__tier-expanded[data-tier="shipping"]');
    const expandedDiscount15Tier = bundleContainer.querySelector('.bundle-creator-new__tier-expanded[data-tier="discount15"]');
    if (expandedShippingTier) {
      const connector = expandedShippingTier.querySelector('.bundle-creator-new__tier-connector-expanded');
      if (connector) connector.classList.toggle('active', totalItems >= 6);
    }
    if (expandedDiscount15Tier) {
      const connector = expandedDiscount15Tier.querySelector('.bundle-creator-new__tier-connector-expanded');
      if (connector) connector.classList.toggle('active', totalItems >= 8);
    }

    // Update expanded progress text
    if (progressTextExpanded) {
      const progressTemplate = progressTemplateFor(remaining);
      if (remaining > 0) {
        progressTextExpanded.innerHTML = progressTemplate.replace('__COUNT__', remaining);
      } else {
        progressTextExpanded.innerHTML = `<span style="color: #000;">${translations.discountUnlocked}</span>`;
      }
    }

    // Update add to cart button
    if (totalItems >= 6) {
      addToCartButton.disabled = false;
      addToCartButton.classList.add('active');
      addToCartButton.querySelector('.bundle-creator-new__add-to-cart-text').innerText = translations.addToCart;
      if (mobileAddToCartBtn) {
        mobileAddToCartBtn.disabled = false;
        mobileAddToCartBtn.classList.add('active');
      }
    } else {
      addToCartButton.disabled = true;
      addToCartButton.classList.remove('active');
      addToCartButton.querySelector('.bundle-creator-new__add-to-cart-text').innerText = translations.addToCart;
      if (mobileAddToCartBtn) {
        mobileAddToCartBtn.disabled = true;
        mobileAddToCartBtn.classList.remove('active');
      }
    }

    // Recalculate scroll container height since selected products panel height changed
    updateScrollContainerHeight();
  }
});
